import { readUserExpertInfoOfChannel } from '@dinosband/bv-main-client'
import { DataCenter_ProxyType } from '../abstract'

interface ChannelExpertKey {
  channelId: number
  userId: number
}

export class ChannelExperts extends DataCenter_ProxyType<ChannelExpertKey, boolean> {

  protected _key = (id: ChannelExpertKey) => `${id.channelId / id.userId}`

  async init () {
    //
  }

  protected async query (key: ChannelExpertKey) {
    const expertInfo = await readUserExpertInfoOfChannel(await this.mainStore.apollo.getClient(), key.channelId, key.userId)
    return !!expertInfo?.approvedAt?.length
  }

}
